"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorMode = exports.Grayscale = exports.TokenBackgroundType = exports.TokenGenericType = exports.TokenMode = exports.TokenGroup = void 0;
var TokenGroup;
(function (TokenGroup) {
    TokenGroup["textIcons"] = "textIcons";
    TokenGroup["text"] = "text";
    TokenGroup["controlsSurfaces"] = "controlsSurfaces";
    TokenGroup["surface"] = "surface";
    TokenGroup["backgrounds"] = "backgrounds";
    TokenGroup["background"] = "background";
    TokenGroup["overlay"] = "overlay";
    TokenGroup["outline"] = "outline";
})(TokenGroup || (exports.TokenGroup = TokenGroup = {}));
var TokenMode;
(function (TokenMode) {
    TokenMode["default"] = "default";
    TokenMode["inverse"] = "inverse";
})(TokenMode || (exports.TokenMode = TokenMode = {}));
var TokenGenericType;
(function (TokenGenericType) {
    TokenGenericType["onDark"] = "onDark";
    TokenGenericType["onLight"] = "onLight";
})(TokenGenericType || (exports.TokenGenericType = TokenGenericType = {}));
var TokenBackgroundType;
(function (TokenBackgroundType) {
    TokenBackgroundType["dark"] = "dark";
    TokenBackgroundType["light"] = "light";
})(TokenBackgroundType || (exports.TokenBackgroundType = TokenBackgroundType = {}));
var Grayscale;
(function (Grayscale) {
    Grayscale["coolGray"] = "coolGray";
    Grayscale["gray"] = "gray";
})(Grayscale || (exports.Grayscale = Grayscale = {}));
exports.ColorMode = {
    LIGHT: 'light',
    DARK: 'dark',
};
//# sourceMappingURL=types.js.map